function SummaryCard({ title, children, styles }) {
  return (
    <div className={`${styles.item} ${styles.summaryCard}`}>
      <h1 className={styles.title}>{title}</h1>
      {children}
    </div>
  )
}

export default SummaryCard;